import { Routes, Route } from "react-router-dom";
import { routes } from "./config/appRoutes";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import useAuth from "./hooks/useAuth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LandingPage from "./pages/landingPage/LandingPage";

function App() {
  const { isLoading, isLoggedIn } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
          <p className="mt-4 text-lg font-semibold text-gray-700">
            Loading, please wait...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen ">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        {routes.map(({ path, isPrivate, ...props }, index) => (
          <Route
            key={index}
            path={path}
            element={
              isPrivate ? (
                <PrivateRoute isLoggedIn={isLoggedIn} {...props} />
              ) : (
                <PublicRoute isLoggedIn={isLoggedIn} {...props} />
              )
            }
          />
        ))}

        <Route path="*" element={<h1>404 Not Found</h1>} />
      </Routes>
    </div>
  );
}

export default App;
